import sabAPI from '@/api/sab'

const state = {
  signedUp: false,
  facebookEmail: null,
  authenticated: false,
  loading: true,
  loaded: false
}

const getters = {}

async function tryAuthenticate(commit, body, shouldThrow) {
  commit('SET_LOADING', true)

  try {
    await body()
    commit('SET_AUTHENTICATED', true)
    commit('SET_LOADING', false)
  } catch (err) {
    commit('SET_AUTHENTICATED', false)
    commit('SET_LOADING', false)

    if (shouldThrow) {
      throw err
    }
  }
}

const actions = {
  async signIn({ commit }, { credentials }) {
    await tryAuthenticate(commit, async () => sabAPI.signIn(credentials), true)
  },
  signUp({ commit }, { credentials, extraData, recaptchaToken, authenticationPlatform, privacyPreferences }) {
    return sabAPI.signUp(credentials, extraData, authenticationPlatform, recaptchaToken, privacyPreferences).then(() => {
      commit('SET_SIGNED_UP', true)
    })
  },
  async refreshToken({ commit }) {
    await tryAuthenticate(commit, async () => sabAPI.refreshToken(), false)
    commit('SET_LOADED', true)
  },
  async signOut({ dispatch, commit }) {
    try {
      await sabAPI.signOut()
      commit('SET_SIGNED_UP', false)
      commit('SET_AUTHENTICATED', false)
      dispatch('user/unset', {}, { root: true })
    } catch {}
  }
}

const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_LOADED(state, loaded) {
    state.loaded = loaded
  },
  SET_AUTHENTICATED(state, authenticated) {
    state.authenticated = authenticated
  },
  SET_FACEBOOK_EMAIL(state, email) {
    state.facebookEmail = email
  },
  SET_SIGNED_UP(state, signedUp) {
    state.signedUp = signedUp
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
